var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2086(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1684.125,
    height: 525.174,
    viewBox: "0 0 1684.125 525.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Talk_to_an_expert",
    x: 93,
    y: 307.174,
    width: 214,
    height: 137,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Choose_a_Plan",
    x: 372.301,
    y: 0,
    width: 288,
    height: 99,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pick_an_interface",
    x: 670.688,
    y: 309.674,
    width: 328,
    height: 99,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Let_us_do_the_work",
    x: 962.918,
    y: 0,
    width: 362,
    height: 99,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Start_Calling",
    x: 1322.125,
    y: 307.843,
    width: 260,
    height: 99,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "We_ll_help_you_find_the_best_option_that_suits_your_needs.",
    x: 0,
    y: 404.174,
    width: 400,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Whether_you_need_PBX_feature_or_not_there_s_a_plan_that_meets_your_needs.",
    x: 320.301,
    y: 59,
    width: 392,
    height: 153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pick_the_interface_that_works_best_for_you.",
    x: 633.688,
    y: 368.674,
    width: 402,
    height: 121,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Our_team_will_help_you_to_set_up_everything_with_minimal_disruption.",
    x: 941.918,
    y: 59,
    width: 404,
    height: 153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Empower_your_internal_team_to_call_anywhere_from_everywhere_within_Microsoft_Teams",
    x: 1220.125,
    y: 366.843,
    width: 464,
    height: 153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_66",
    x: 760.736,
    y: 140.109,
    width: 154.356,
    height: 154.356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.317,
    dy: 3.317,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.106,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a09d9d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_68",
    x: 450.317,
    y: 234.136,
    width: 154.356,
    height: 154.356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.317,
    dy: 3.317,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.106,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a09d9d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_71",
    x: 134.016,
    y: 137.698,
    width: 154.356,
    height: 154.356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.317,
    dy: 3.317,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.106,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a09d9d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_73",
    x: 1077.934,
    y: 233.98,
    width: 154.356,
    height: 154.356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.317,
    dy: 3.317,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.106,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a09d9d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_75",
    x: 1386.142,
    y: 137.543,
    width: 154.356,
    height: 154.356,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.317,
    dy: 3.317,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.106,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a09d9d",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2086",
    "data-name": "Group 2086",
    transform: "translate(-125.813 -5745.268)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Talk_to_an_expert)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Talk_to_an_expert-2",
    "data-name": "Talk to an expert",
    transform: "translate(200 368.17)",
    fill: "#3c3c3b",
    fontSize: 32,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53,
    y: 0
  }, "Talk to"), /*#__PURE__*/React.createElement("tspan", {
    x: -76,
    y: 38
  }, "an expert"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Choose_a_Plan)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Choose_a_Plan-2",
    "data-name": "Choose a Plan",
    transform: "translate(516.3 61)",
    fill: "#3c3c3b",
    fontSize: 32,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -113,
    y: 0
  }, "Choose a Plan"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Pick_an_interface)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Pick_an_interface-2",
    "data-name": "Pick an interface",
    transform: "translate(834.69 370.67)",
    fill: "#3c3c3b",
    fontSize: 32,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -133,
    y: 0
  }, "Pick an interface"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Let_us_do_the_work)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Let_us_do_the_work-2",
    "data-name": "Let us do the work",
    transform: "translate(1143.92 61)",
    fill: "#3c3c3b",
    fontSize: 32,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -150,
    y: 0
  }, "Let us do the work"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Start_Calling)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Start_Calling-2",
    "data-name": "Start Calling",
    transform: "translate(1452.13 368.84)",
    fill: "#3c3c3b",
    fontSize: 32,
    fontFamily: "Gotham-Medium, Gotham",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -99,
    y: 0
  }, "Start Calling"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#We_ll_help_you_find_the_best_option_that_suits_your_needs.)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "We_ll_help_you_find_the_best_option_that_suits_your_needs.-2",
    "data-name": "We'll help you find the best option that suits your needs.",
    transform: "translate(200 457.17)",
    fill: "#3c3c3b",
    fontSize: 24,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -162,
    y: 0
  }, "We&apos;ll help you find the best"), /*#__PURE__*/React.createElement("tspan", {
    x: -169,
    y: 32
  }, "option that suits your needs."))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Whether_you_need_PBX_feature_or_not_there_s_a_plan_that_meets_your_needs.)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Whether_you_need_PBX_feature_or_not_there_s_a_plan_that_meets_your_needs.-2",
    "data-name": "Whether you need PBX feature or not, there's a plan that meets your needs.",
    transform: "translate(516.3 112)",
    fill: "#3c3c3b",
    fontSize: 24,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -139,
    y: 0
  }, "Whether you need PBX"), /*#__PURE__*/React.createElement("tspan", {
    x: -139,
    y: 32
  }, "feature or not, there&apos;s a"), /*#__PURE__*/React.createElement("tspan", {
    x: -165,
    y: 64
  }, "plan that meets your needs."))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Pick_the_interface_that_works_best_for_you.)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Pick_the_interface_that_works_best_for_you.-2",
    "data-name": "Pick the interface that works best for you.",
    transform: "translate(834.69 421.67)",
    fill: "#3c3c3b",
    fontSize: 24,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -170,
    y: 0
  }, "Pick the interface that works"), /*#__PURE__*/React.createElement("tspan", {
    x: -74,
    y: 32
  }, "best for you."))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Our_team_will_help_you_to_set_up_everything_with_minimal_disruption.)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Our_team_will_help_you_to_set_up_everything_with_minimal_disruption.-2",
    "data-name": "Our team will help you to set up everything, with minimal disruption.",
    transform: "translate(1143.92 112)",
    fill: "#3c3c3b",
    fontSize: 24,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -171,
    y: 0
  }, "Our team will help you to set"), /*#__PURE__*/React.createElement("tspan", {
    x: -164,
    y: 32
  }, "up everything, with minimal"), /*#__PURE__*/React.createElement("tspan", {
    x: -63,
    y: 64
  }, "disruption."))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Empower_your_internal_team_to_call_anywhere_from_everywhere_within_Microsoft_Teams)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Empower_your_internal_team_to_call_anywhere_from_everywhere_within_Microsoft_Teams-2",
    "data-name": "Empower your internal team to call anywhere from everywhere within Microsoft Teams",
    transform: "translate(1452.13 419.84)",
    fill: "#3c3c3b",
    fontSize: 24,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -169,
    y: 0
  }, "Empower your internal team"), /*#__PURE__*/React.createElement("tspan", {
    x: -201,
    y: 32
  }, "to call anywhere from everywhere"), /*#__PURE__*/React.createElement("tspan", {
    x: -136,
    y: 64
  }, "within Microsoft Teams"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2085",
    "data-name": "Group 2085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(446.869 5959.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    "data-name": "Path 3458",
    d: "M160.909,222.988h17.876v91.3h60.128",
    transform: "translate(-160.909 -222.988)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1.17,
    strokeDasharray: 4.681
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    "data-name": "Path 3459",
    d: "M202.449,277.821l5.332-5.135-5.332-5.332Z",
    transform: "translate(-121.955 -181.383)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1222",
    "data-name": "Group 1222",
    transform: "translate(759.998 5956.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M322.5,315.615h17.876v-91.3h60.128",
    transform: "translate(-322.502 -219.178)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1.17,
    strokeDasharray: 4.681
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M364.041,221.663l5.332,5.135-5.332,5.332Z",
    transform: "translate(-283.547 -221.663)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1223",
    "data-name": "Group 1223",
    transform: "translate(1074.149 5959.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M484.622,222.908H502.5v91.3h60.128",
    transform: "translate(-484.622 -222.908)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1.17,
    strokeDasharray: 4.681
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M526.162,277.74l5.332-5.135-5.332-5.332Z",
    transform: "translate(-445.668 -181.303)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1224",
    "data-name": "Group 1224",
    transform: "translate(1387.278 5956.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M646.215,315.535H664.09v-91.3h60.128",
    transform: "translate(-646.215 -219.097)",
    fill: "none",
    stroke: "#3c3c3b",
    strokeWidth: 1.17,
    strokeDasharray: 4.681
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    d: "M687.754,221.583l5.332,5.135-5.332,5.332Z",
    transform: "translate(-607.26 -221.583)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M470.325,285.272a89.612,89.612,0,1,1,0-179.224",
    transform: "translate(490.083 5763.581)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Ellipse_66)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66-2",
    "data-name": "Ellipse 66",
    cx: 73.861,
    cy: 73.861,
    r: 73.861,
    transform: "translate(760.74 140.11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 67.953,
    cy: 67.953,
    r: 67.953,
    transform: "translate(892.454 5891.287)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    d: "M312.193,473.862a89.613,89.613,0,0,1,0-179.226",
    transform: "translate(337.794 5669.018)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Ellipse_68)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68-2",
    "data-name": "Ellipse 68",
    cx: 73.861,
    cy: 73.861,
    r: 73.861,
    transform: "translate(450.32 234.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 67.953,
    cy: 67.953,
    r: 67.953,
    transform: "translate(582.035 5985.314)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M145.867,285.272a89.612,89.612,0,0,1,0-179.224",
    transform: "translate(187.819 5761.17)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Ellipse_71)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71-2",
    "data-name": "Ellipse 71",
    cx: 73.861,
    cy: 73.861,
    r: 73.861,
    transform: "translate(134.02 137.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 67.953,
    cy: 67.953,
    r: 67.953,
    transform: "translate(265.733 5888.876)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M635.906,473.78a89.612,89.612,0,0,1,0-179.224",
    transform: "translate(641.697 5668.943)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Ellipse_73)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73-2",
    "data-name": "Ellipse 73",
    cx: 73.861,
    cy: 73.861,
    r: 73.861,
    transform: "translate(1077.93 233.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 67.953,
    cy: 67.953,
    r: 67.953,
    transform: "translate(1209.651 5985.158)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M792.036,285.191a89.612,89.612,0,1,1,0-179.224",
    transform: "translate(793.775 5761.095)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 125.81, 5745.27)",
    filter: "url(#Ellipse_75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75-2",
    "data-name": "Ellipse 75",
    cx: 73.861,
    cy: 73.861,
    r: 73.861,
    transform: "translate(1386.14 137.54)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 67.953,
    cy: 67.953,
    r: 67.953,
    transform: "translate(1517.859 5888.721)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "customer-support",
    transform: "translate(290.587 5915.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M70.541,65.777c-1.614-4.8-8.049-7.812-12.636-9.828-1.8-.787-6.773-2.123-7.371-4.386a4.682,4.682,0,0,1-.01-2.321,4.486,4.486,0,0,1-.847.084H46.688a4.323,4.323,0,1,1,0-8.647h2.989a4.311,4.311,0,0,1,2.679.931,19.236,19.236,0,0,0,3.17-.694,26.814,26.814,0,0,0,2.555-8.834c.976-12.062-6.419-19.12-17.022-17.9-7.709.887-12.314,6.636-12.812,14.036a25.489,25.489,0,0,0,5.264,17.2c1.3,1.787,2.668,2.935,2.458,5.089-.244,2.546-2.966,3.255-4.913,4.038a56.246,56.246,0,0,0-5.965,2.983c-4.042,2.232-8.479,4.921-9.476,8.6-2.208,8.151,5.25,10.62,11.407,11.759a92.183,92.183,0,0,0,16.143,1.052c8.865,0,24.805-.355,27.376-7.019a11.1,11.1,0,0,0,0-6.143Z",
    transform: "translate(0 -1.795)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M52.314,41.988a2.259,2.259,0,0,0-1.89-1.028H47.435a2.252,2.252,0,1,0,0,4.5h2.989a2.233,2.233,0,0,0,1.987-1.218,20.213,20.213,0,0,0,10.337-3.481,3.712,3.712,0,0,0,2.021.6h.188A3.757,3.757,0,0,0,68.714,37.6V30.091A3.746,3.746,0,0,0,66.572,26.7a22.751,22.751,0,0,0-45.454,0,3.744,3.744,0,0,0-2.143,3.386V37.6a3.757,3.757,0,0,0,3.755,3.762h.19A3.758,3.758,0,0,0,26.676,37.6V30.091a3.749,3.749,0,0,0-2.091-3.36,19.285,19.285,0,0,1,38.516,0,3.751,3.751,0,0,0-2.088,3.36V37.6a3.778,3.778,0,0,0,.268,1.4,18.4,18.4,0,0,1-8.967,2.992Z",
    transform: "translate(-0.745)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "choice",
    transform: "translate(627.076 6022.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M19.858,17.233a6.972,6.972,0,0,1,13.944,0v5.619a4.739,4.739,0,0,0,3.35-4.524V4.73A4.735,4.735,0,0,0,32.421,0H21.238a4.735,4.735,0,0,0-4.73,4.73v13.6a4.738,4.738,0,0,0,3.35,4.524Zm0,0",
    transform: "translate(-14.497)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    d: "M222.628,0H211.445a4.735,4.735,0,0,0-4.73,4.73v13.6a4.735,4.735,0,0,0,4.73,4.73h11.183a4.735,4.735,0,0,0,4.73-4.73V4.73A4.735,4.735,0,0,0,222.628,0Zm0,0",
    transform: "translate(-181.525)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M32.44,129.416a3.351,3.351,0,0,0-3.351,3.351V131.06a3.351,3.351,0,0,0-6.7,0v-1.436a3.351,3.351,0,0,0-3.082-3.34c-.089-.007-.179-.011-.269-.011a3.352,3.352,0,0,0-3.351,3.351V117.262a3.351,3.351,0,1,0-6.7,0v28.771l-.145-.019-2.065-8.837a3.352,3.352,0,0,0-4.026-2.5,2.613,2.613,0,0,0-2.659,3.351l2.394,10.245c1.252,8.016,7.732,14.15,7.732,14.15H30.573A31.724,31.724,0,0,0,35.79,145l0-12.231a3.351,3.351,0,0,0-3.351-3.351Zm0,0",
    transform: "translate(0 -100.029)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass",
    transform: "translate(932.304 5931.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M392.054,8.571a5.823,5.823,0,1,0-2.482,2.482l2.482,2.482a1.756,1.756,0,0,0,2.482-2.485Zm-7.541-2.717A2.342,2.342,0,1,1,386.855,8.2,2.349,2.349,0,0,1,384.513,5.855Z",
    transform: "translate(-338.845)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M4.1,14.052H33.373a4.118,4.118,0,0,0,4.1-4.1V4.1a4.118,4.118,0,0,0-4.1-4.1H4.1A4.118,4.118,0,0,0,0,4.1V9.953a4.118,4.118,0,0,0,4.1,4.1Z",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M202.706,169.333H173.431a4.118,4.118,0,0,0-4.1,4.1v29.274a4.118,4.118,0,0,0,4.1,4.1h29.274a4.118,4.118,0,0,0,4.1-4.1V173.431A4.118,4.118,0,0,0,202.706,169.333ZM188.069,178.7a3.513,3.513,0,1,1-3.513,3.513A3.508,3.508,0,0,1,188.069,178.7Zm7.026,14.637a1.769,1.769,0,0,1-1.756,1.756H182.8a1.769,1.769,0,0,1-1.756-1.756v-.867a4.679,4.679,0,0,1,4.918-4.4h4.215a4.679,4.679,0,0,1,4.918,4.4Z",
    transform: "translate(-150.598 -150.598)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 7.026,
    cy: 7.026,
    r: 7.026,
    transform: "translate(0 40.984)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M1.756,236.346H12.3a1.756,1.756,0,1,0,0-3.513H1.756a1.756,1.756,0,1,0,0,3.513Z",
    transform: "translate(0 -207.072)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M1.756,299.846H12.3a1.756,1.756,0,0,0,0-3.513H1.756a1.756,1.756,0,0,0,0,3.513Z",
    transform: "translate(0 -263.546)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M1.756,172.846H12.3a1.756,1.756,0,1,0,0-3.513H1.756a1.756,1.756,0,1,0,0,3.513Z",
    transform: "translate(0 -150.598)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "settings_1_",
    "data-name": "settings (1)",
    transform: "translate(1249.299 6024.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1248",
    "data-name": "Group 1248",
    transform: "translate(0.006 0.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1247",
    "data-name": "Group 1247",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1246",
    "data-name": "Group 1246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M123.583,282.023h0C123.618,281.988,123.616,281.99,123.583,282.023Z",
    transform: "translate(-109.926 -250.822)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M55.412,23.408,52.6,22.731a24.653,24.653,0,0,0-3.14-7.572l1.427-2.4a1.658,1.658,0,0,0-.253-2.021L45.956,6.067a1.66,1.66,0,0,0-2.021-.253l-2.4,1.427A24.653,24.653,0,0,0,33.967,4.1L33.29,1.286A1.658,1.658,0,0,0,31.682.031H25.049a1.658,1.658,0,0,0-1.608,1.255L22.764,4.1a24.653,24.653,0,0,0-7.572,3.14L12.8,5.815a1.658,1.658,0,0,0-2.021.253L6.1,10.742a1.658,1.658,0,0,0-.253,2.021l1.427,2.4a24.653,24.653,0,0,0-3.14,7.572l-2.815.677A1.658,1.658,0,0,0,.064,25.016v6.633a1.656,1.656,0,0,0,1.257,1.608l2.815.677a24.193,24.193,0,0,0,1.811,5.1c1.218-1.223,7.335-7.366,7.774-7.8-.022-.112-.259-2.236-.265-2.65a14.909,14.909,0,1,1,29.816-.2A14.745,14.745,0,0,1,29.545,43.15a13.114,13.114,0,0,1-4.081-.172l-7.783,7.783a24.2,24.2,0,0,0,5.083,1.8l.677,2.817a1.658,1.658,0,0,0,1.608,1.255h6.633a1.658,1.658,0,0,0,1.608-1.255l.677-2.815a24.653,24.653,0,0,0,7.572-3.14l2.4,1.427a1.661,1.661,0,0,0,2.021-.253l4.675-4.675a1.658,1.658,0,0,0,.253-2.021l-1.427-2.4a24.6,24.6,0,0,0,3.14-7.574l2.813-.675a1.656,1.656,0,0,0,1.257-1.608V25.016A1.658,1.658,0,0,0,55.412,23.408Z",
    transform: "translate(-0.064 -0.031)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    transform: "translate(-0.001 16.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M39.529,159.565a1.638,1.638,0,0,0-2.747-.753L33,162.6a3.316,3.316,0,1,1-4.69-4.69l3.786-3.786a1.639,1.639,0,0,0-.754-2.747,11.618,11.618,0,0,0-14.449,9.074,11.741,11.741,0,0,0,.473,6.039L1.454,182.4a4.988,4.988,0,1,0,7.054,7.054l15.91-15.91a12.135,12.135,0,0,0,8.17-.09C37.6,171.683,41.1,165.749,39.529,159.565Z",
    transform: "translate(0.001 -150.986)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_",
    transform: "translate(1551.716 5925.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M186.429,59.01c.074-8.652-7.3-16.584-16.427-17.681-.182-.022-.379-.054-.589-.089a8.538,8.538,0,0,0-1.391-.152,2.338,2.338,0,0,0-2.5,2.1,2.425,2.425,0,0,0,.362,1.9,3.6,3.6,0,0,0,2.586,1.112c.257.035.5.068.7.114,8.2,1.833,10.967,4.716,12.317,12.85.033.2.048.444.064.7.059.972.182,3,2.357,3h0a3.863,3.863,0,0,0,.578-.047c2.025-.308,1.962-2.157,1.931-3.046a4.5,4.5,0,0,1,0-.644A.87.87,0,0,0,186.429,59.01Z",
    transform: "translate(-130.517 -33.257)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M163.42,4.9c.243.018.473.034.665.064,13.473,2.072,19.669,8.455,21.386,22.033a7.948,7.948,0,0,1,.039.81c.017,1.061.052,3.268,2.422,3.313H188a2.325,2.325,0,0,0,1.757-.667,3.712,3.712,0,0,0,.645-2.839c-.01-.226-.02-.439-.017-.625C190.561,13.1,178.54.507,164.666.038a.962.962,0,0,0-.168.009,1.16,1.16,0,0,1-.164.009c-.138,0-.309-.012-.489-.024-.218-.015-.466-.032-.716-.032a2.438,2.438,0,0,0-2.683,2.507C160.321,4.67,162.414,4.823,163.42,4.9Z",
    transform: "translate(-126.446)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M58.373,57.513c-.286-.219-.583-.445-.86-.669-1.471-1.184-3.036-2.275-4.549-3.33l-.941-.657a9.392,9.392,0,0,0-5.328-2.023c-2.218,0-4.152,1.225-5.748,3.642a3.054,3.054,0,0,1-2.622,1.592,5.206,5.206,0,0,1-2.111-.53A25.416,25.416,0,0,1,22.933,42.605c-1.235-2.776-.835-4.59,1.339-6.067,1.234-.838,3.532-2.4,3.369-5.385-.184-3.392-7.668-13.6-10.822-14.757a6.143,6.143,0,0,0-4.177-.011C9.018,17.6,6.416,19.744,5.119,22.574a11.5,11.5,0,0,0,.164,9.285A74.907,74.907,0,0,0,21.72,56.882,79.677,79.677,0,0,0,46.657,73.44a13.811,13.811,0,0,0,2.466.733c.229.051.426.1.57.135a.957.957,0,0,0,.242.034h.077c4.572,0,10.061-4.178,11.747-8.941C63.237,61.23,60.541,59.169,58.373,57.513Z",
    transform: "translate(0 -12.971)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M173.256,83.557a2.837,2.837,0,0,0-2.983,1.719,2.3,2.3,0,0,0,.1,2,3,3,0,0,0,2.261,1.2c3.067.492,4.642,2.188,4.957,5.337a2.525,2.525,0,0,0,2.4,2.493h0a2.369,2.369,0,0,0,.285-.017c1.527-.182,2.267-1.3,2.2-3.333a9.519,9.519,0,0,0-2.97-6.44A8.863,8.863,0,0,0,173.256,83.557Z",
    transform: "translate(-134.261 -67.63)",
    fill: "#fafafa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2086);
export default __webpack_public_path__ + "static/media/Group 2086.bb8f1a6f85ee2e10aca081d42834f876.svg";
export { ForwardRef as ReactComponent };